import { ButtonViewProps } from '../types.ts';
import { ButtonByType } from '../components/index.ts';

export function SecondaryButton(props: ButtonViewProps) {
  return <ButtonByType {...props} color="white-primary" background="pink" border="white-primary" />;
}
